import React from 'react'
import clsx from 'clsx'
import { ZinButton } from '@tnl/zin-react'
import { useSiteContext } from '@shared/contexts/MkSiteContext'

export interface FormFooterLinkConfig {
  text: string
  link?: string
  onClick?: () => void
  className?: string
  target?: '_self' | '_blank'
  rel?: string
  icon?: string
  iconPosition?: 'left' | 'right'
}

export interface FormFooterProps {
  className?: string
  /**
   * Deprecated: variant is no longer used to determine default links.
   * Left as a loose string for backward compatibility with existing usages.
   */
  variant?: string
  links?: FormFooterLinkConfig[]
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const FormFooter: React.FC<FormFooterProps> = ({ className, links, variant: _variant }) => {
  const { themeBrand } = useSiteContext()

  // Only render provided links. _variant is ignored (kept for backward compatibility)
  const items: FormFooterLinkConfig[] = links && links.length > 0 ? links : []

  if (!items || items.length === 0) return null

  if (themeBrand === 'ebac') {
    require(`./FormFooter_ebac.scss`)
  }

  return (
    <div className={clsx('mt-6 text-left space-y-3', className)}>
      {items
        .filter((config) => config.text) // Filter out items without text before mapping
        .map((config, index) => {
          // Create a unique key using text, icon, and index to prevent duplicates
          const uniqueKey = `footer-button-${config.text}-${config.icon || 'no-icon'}-${index}`

          return (
            <div key={uniqueKey}>
              <ZinButton
                variant="link"
                type="button"
                color="secondary"
                icon={config.icon}
                iconPosition={config.iconPosition}
                onClick={() => {
                  if (config.onClick) {
                    config.onClick()
                  } else if (config.link) {
                    window.open(config.link, config.target ?? '_self')
                  }
                }}
                className={clsx('formFooter text-core-text-secondary hover:text-core-text-primary text-sm underline transition-colors duration-200', config.className)}>
                {config.text}
              </ZinButton>
            </div>
          )
        })}
    </div>
  )
}
